import React from 'react';
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import TeamCarousel from './TeamCards';

const QuemSomos = () => {
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  return (
    <section className="about-team-section" id="quem-somos">
      <div className="container">
        <div className="about-team-layout">
          {/* About Section - Quem Somos (Left Side) */}
          <div className="about-content">
            {/* Vertical "Quem Somos" Text */}
            <p className="section-subtitle-vertical">Quem Somos</p>
            
            <div className="section-content">
              <h2 className="section-title h2">
                Realizando sonhos através de experiências únicas!
              </h2>
              
              <p className="section-text">
                Somos uma empresa especializada na criação de formaturas e eventos personalizados, 
                com itens desenvolvidos junto à turma e apresentados em um moderno projeto 3D. 
                Nossa paixão é transformar a sua formatura em um momento único e memorável.
              </p>

              <p className="section-text">
                Com anos de experiência no mercado, oferecemos soluções completas para sua formatura, 
                desde a criação de convites personalizados até a organização completa do evento. 
                Cada projeto é desenvolvido com atenção aos detalhes e dedicação total.
              </p>
              
              <div className="stats-grid" ref={ref}>
                <div className="stat-item" data-aos="zoom-in" data-aos-delay="200">
                  <div className="stat-icon">
                    <i className="fas fa-trophy"></i>
                  </div>
                  <div className="stat-content">
                    <h3 className="stat-number">
                      {inView ? <CountUp end={100} duration={2} />  : '0'}+
                    </h3>
                    <p className="stat-label">Formaturas</p>
                  </div>
                </div>
                
                <div className="stat-item" data-aos="zoom-in" data-aos-delay="400">
                  <div className="stat-icon">
                    <i className="fas fa-star"></i>
                  </div>
                  <div className="stat-content">
                    <h3 className="stat-number">
                      {inView ? <CountUp end={5.0} decimals={1} duration={2} /> : '0.0'}
                    </h3>
                    <p className="stat-label">Avaliação</p>
                  </div>
                </div>
                
                <div className="stat-item" data-aos="zoom-in" data-aos-delay="600">
                  <div className="stat-icon">
                    <i className="fas fa-users"></i>
                  </div>
                  <div className="stat-content">
                    <h3 className="stat-number">
                      {inView ? <CountUp end={1000} duration={2} /> : '0'}+
                    </h3>
                    <p className="stat-label">Formandos</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Team Section - Nossa Equipe (Right Side) */}
          <div className="team-content">
            <TeamCarousel />
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuemSomos;